import { render, staticRenderFns } from "./news.html?vue&type=template&id=73675fd2&scoped=true&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "./news.scss?vue&type=style&index=0&id=73675fd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73675fd2",
  null
  
)

export default component.exports